<script>
  import { onMount } from 'svelte';
  let showModal = false;
  let micDenied = false;

  const checkMicPermission = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

      switch (permissionStatus.state) {
        case 'granted':
          showModal = false;
          break;
        case 'denied':
          showModal = true;
          micDenied = true;
          break;
        default:
          showModal = true;
          micDenied = false;
          break;
      }
    } catch (error) {
      console.error('マイクの権限確認中にエラーが発生しました', error);
    }
  };

  const requestMicAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      showModal = false;
    } catch (error) {
      console.error('マイクへのアクセスが拒否されました', error);
      location.reload();
      showModal = true;
    }
  };

  const modalOkClick = async () => {
    showModal = false;
    await requestMicAccess();
  };

  onMount(() => checkMicPermission());

</script>

{#if showModal}
  <div class="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-10">
    <div class="bg-white px-4 py-6 rounded-lg shadow-lg text-left z-20 max-w-xs">
      <p class="text-lg font-bold text-black">マイクの使用許可</p>
      <div class="pt-6"></div>
      <img class="mx-auto h-[180px] w-[140px]" src="/images/mic_image.webp" alt="micイメージ" />
      <div class="pt-6"></div>
      {#if micDenied}
        <p class="text-sm text-site-sub-black">マイクへのアクセスが拒否されています。アクセス拒否を解除する方法はマニュアルを確認してください。</p>
        <div class="pt-6"></div>
        <a href="https://support.voireq.co.jp/hc/ja/articles/40296080380697-%E3%83%9E%E3%82%A4%E3%82%AF%E3%81%B8%E3%81%AE%E3%82%A2%E3%82%AF%E3%82%BB%E3%82%B9%E8%A8%B1%E5%8F%AF%E6%A8%A9%E9%99%90%E3%81%AE%E3%83%AA%E3%82%BB%E3%83%83%E3%83%88%E6%96%B9%E6%B3%95" target="_blank" class="css-btn css-btn-primary">
          マニュアル確認
        </a>
        <div class="pt-6"></div>
        <button on:click={modalOkClick} class="css-btn css-btn-primary">解除しました</button>
      {:else}
        <p class="text-sm text-site-sub-black">
          マイクの使用を許可しないと録音機能が<br/>
          <span class="font-bold text-social-google text-lg">
            利用できません。
          </span><br/>
          マイクの許可を必ずお願いいたします。
        </p>
        <div class="pt-6"></div>
        <button on:click={modalOkClick} class="css-btn css-btn-primary">OK</button>
      {/if}
    </div>
  </div>
{/if}
